import { MessageHTML } from '@/components/commons/MessageHTML'
import classNames from 'classnames'
import { useState } from 'react'
import './ForwardMessagePreview.scoped.sass'

export default function ForwardMessagePreview (props) {
  const [isForwardCollapsed, setIsForwardCollapsed] = useState(false)
  
  return (<div className='forward-html-preview'>
    <div className='forward-html-preview-title'>
      <span>Forwarding:</span>
      <span className='collapser' onClick={() => setIsForwardCollapsed(!isForwardCollapsed)}>
        {isForwardCollapsed ? 'Show' : 'Hide'}
      </span>
    </div>
    <div className={classNames('forward-html-preview-content', { collapsed: isForwardCollapsed })}>
      <MessageHTML html={props.draft?.additionalBody}/>
    </div>
  </div>)
}
